<template>
  <div>
    <div class="main-content">
      <HeaderBack
        @back="returnback"
      >
        <!-- <span
          v-if="viewPage.text"
          slot="statistic"
          class="select-item-span"
          @click="showPicker"
        >
          {{ viewPage.text }}<i class=" margin-left-6 iconfont iconicon-test17" />
        </span> -->
        <template #center>
          <choose-type
            v-if="typeOptions.length"
            :value="viewPage.value"
            :options="typeOptions"
            @change="handleChangeType"
          />
        </template>
      </HeaderBack>
      <over-view v-if="viewPage.value==='0'" />
      <dev-statistic v-else-if="viewPage.value==='1'" />
      <rec-statistic v-else-if="viewPage.value==='2'" />
      <follow-statistic v-else-if="viewPage.value==='3'" />
      <cube-loading v-if="!itemLists.length" />
      <Footer />
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import OverView from './OverView'
import DevStatistic from './DevelopStatistic'
import RecStatistic from './RecStatistic2'
import FollowStatistic from './FollowStatistic'
import HeaderBack from '@/components/mobile/HeaderBack'
import ChooseType from '@/components/mobile/ChooseType'
import Footer from './components/FooterComponents'

export default {
  components: {
    OverView,
    Footer,
    DevStatistic,
    RecStatistic,
    FollowStatistic,
    HeaderBack,
    ChooseType
  },
  data () {
    return {
      viewPage: {
        value: null,
        text: ''
      },
      visible: false,
      defaultValue: [],
      itemLists: []
    }
  },
  computed: {
    ...mapState('statistic', ['mobileItemList', 'permissionMenuList', 'viewPages', 'customTimeRange']),
    typeOptions () {
      return this.itemLists.map(item => {
        return {
          key: item.value,
          name: item.text
        }
      })
    }
  },
  watch: {
    permissionMenuList (val) {
      if (!val) return
      if (val.statistics) {
        if (val.statistics.child) {
          let array = []
          for (const key in val.statistics.child) {
            if (val.statistics.child[key].state) {
              if (key === 'statistics-all') {
                array.push({
                  text: val.statistics.child[key].name,
                  value: '0'
                })
              } else if (key === 'statistics-dev') {
                array.push({
                  text: val.statistics.child[key].name,
                  value: '1'
                })
              } else if (key === 'statistics-rec') {
                array.push({
                  text: val.statistics.child[key].name,
                  value: '2'
                })
              } else if (key === 'statistics-followup') {
                array.push({
                  text: val.statistics.child[key].name,
                  value: '3'
                })
              }
            }
          }
          this.itemLists = array
          this.viewPage = this.itemLists[0]
        }
      }
    }
  },
  mounted () {
    this.fetchGetPermissionMenu()
    if (this.viewPages) {
      this.viewPage = this.viewPages
    }
  },
  methods: {
    ...mapMutations('statistic', ['setViewPages']),
    ...mapActions('statistic', ['fetchGetPermissionMenu']),
    returnback () {
      this.setViewPages(this.itemLists[0])
      this.$router.go(-1)
    },

    showPicker () {
      if (!this.picker) {
        this.picker = this.$createPicker({
          title: this.$t('message["855"]'),
          data: [this.itemLists],
          onSelect: this.selectHandle,
          onCancel: this.cancelHandle
        })
      }
      this.picker.show()
    },
    selectHandle (selectedVal, selectedIndex, selectedText) {
      const [value] = selectedVal
      this.itemLists.some(values => {
        if (values.value === value) {
          this.viewPage = values
          this.setViewPages(this.viewPage)
          return true
        }
      })
    },
    cancelHandle () {
    },
    handleChangeType (value) {
      /* this.$router.push({
        name: 'InqueryList',
        query: {
          from: this.from,
          type: type
        }
      }) */
      this.itemLists.some(values => {
        if (values.value === value) {
          this.viewPage = values
          this.setViewPages(this.viewPage)
          return true
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.main-content::v-deep {
  width: 375px;
  .bull-size {
    font-size: 30px;
    margin-left: 12px;
    vertical-align: middle;
  }
  .margin-left-15 {
    margin-left: -4px;
    display: inline-block;
  }
  .red {
    color: rgba(245, 118, 118, 1);
  }
  .green {
    color: rgba(27, 198, 160, 1);
  }
  .yellow {
    color: rgba(245, 166, 35, 1);
  }

  .margin-left-6 {
    margin-left: 6px;
  }
  .margin-right-4 {
    margin-right: 4px;
  }
  .margin-left-12 {
    margin-left: 12px;
  }
  .pointer {
    cursor: pointer;
  }
  .circle {
    width: 16px;
    height: 16px;
    line-height: 16px;
    border-radius: 50%;
    font-size: 14px;
    text-align: center;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    background-color: rgba(80, 119, 170, 1);
    float: left;
    margin: 16px 8px 16px 12px;
  }
  .circle-gray {
    width: 16px;
    height: 16px;
    line-height: 16px;
    border-radius: 50%;
    font-size: 14px;
    text-align: center;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    background-color: rgba(204, 204, 204, 1);
    float: left;
    margin: 16px 8px 16px 12px;
  }
  .distribute-content {
    background-color: #fff;
    // height: 484px;
    width: 375px;
    margin-bottom: 12px;
  }
  .statistic-detail {
    margin: 12px auto;
    .second-content {
      position: relative;
      height: 48px;
      border-bottom: solid 1px rgba(219, 219, 219, 1);
      background-color: #fff;
      .number2 {
        position: absolute;
        right: 44px;
        display: inline-block;
        // width: 80px !important;
        // margin-left: 150px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        // height: 48px;
        line-height: 48px;
        vertical-align: middle;
      }
    }
    .normal-content {
      position: relative;
      height: 68px;
      border-bottom: solid 1px rgba(219, 219, 219, 1);
      background-color: #fff;
      .pointer {
        position: absolute;
        right: 18px;
        line-height: 68px;
      }
    }
    .text {
      // width: 60px;
      padding: 0 8px;
      border-right: solid 1px rgba(179, 179, 179, 1);
      display: inline-block;
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 12px;
      vertical-align: middle;
      text-align: center;
    }
    .text2 {
      padding: 0 8px;
      margin-left: 24px;
      border-right: solid 1px rgba(179, 179, 179, 1);
      display: inline-block;
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 12px;
      vertical-align: middle;
      text-align: center;
    }
    .number {
      // width: 80px;
      position: absolute;
      right: 44px;
      display: inline-block;
      // margin-left: 120px;
      font-size: 20px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      // height: 68px;
      line-height: 68px;
      text-align: right;
      vertical-align: middle;
    }
    .persent {
      display: inline-block;
      width: 40px;
      height: 68px;
      line-height: 68px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      vertical-align: middle;
      margin-left: 8px;
    }
    .persent2 {
      width: 40px;
      height: 48px;
      display: inline-block;
      line-height: 48px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(179, 179, 179, 1);
      vertical-align: middle;
      margin-left: 8px;
    }
  }

  .dev-overview-div {
    margin-bottom: 12px;
    .dev-normal-content {
      // height: 68px;
      width: 375px;
      background-color: #fff;
      border-bottom: solid 1px rgba(219, 219, 219, 1);
      .text {
        width: 40px;
        margin-left: 12px;
        font-size: 16px;
        font-weight: 400;
        height: 68px;
        line-height: 68px;
        color: rgba(51, 51, 51, 1);
        display: inline-block;
        vertical-align: middle;
        margin-top: -1px;
      }
      .number {
        float: right;
        // width: 60px;
        text-align: right;
        font-size: 20px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        height: 68px;
        line-height: 68px;
        margin-right: 12px;
      }
    }
  }
  .dev-data-statistic {
    clear: both;
    .level-select-div {
      height: 48px;
      width: 375px;
      background-color: #fff;
      .level-select-text {
        width: 64px;
        height: 48px;
        text-align: left;
        margin-left: 12px;
        font-size: 16px;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 48px;
      }
      .level-icon {
        margin-right: 21px;
        float: right;
        margin-top: 18px;
        color: #cccccc;
      }
    }
    .detail-content {
      height: 48px;
      width: 375px;
      background-color: #fff;
      border-top: solid 1px rgba(219, 219, 219, 1);
      .text-content-ellipsis {
        float: left;
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        white-space: nowrap;
        height: 48px;
        display: block;
        line-height: 48px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
      }
      .number {
        width: 60px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        height: 48px;
        line-height: 48px;
        float: right;
        margin-right: 12px;
        text-align: right;
      }
      .date-second-num {
        width: 80px;
        display: inline-block;
        height: 48px;
        line-height: 48px;
        text-align: right;
      }
      .date-second-data {
        width: 100px;
        display: inline-block;
        height: 48px;
        line-height: 48px;
        margin-left: 12px;
      }
      .date-second-number {
        float: right;
        width: 60px;
        margin-right: 12px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        text-align: right;
        margin-top: 16px;
      }
    }
  }
  .dev-distribute-div {
    height: 510px;
    width: 375px;
    background-color: #fff;
    margin-bottom: 12px;
  }
}
</style>
